import React from 'react';
import { useProfile } from "../../hooks/useProfile.jsx";
import NavHeaderTop from "./NavHeaderTop";
import NavHeaderBottom from "./NavHeaderBottom";
import './style.scss';

const NavHeader = (props) => {
  const { profile, isLoaded, isDarkTheme } = useProfile();

  return (
    <div id="aps-header" className={`aps__nav-header`}>
      <NavHeaderTop profile={profile} isLoaded={isLoaded} isDarkTheme={isDarkTheme} />
      <NavHeaderBottom/>
    </div>
  );
};

export default NavHeader;
